// extracted by mini-css-extract-plugin
export default {"NoticeToUser":"NoticeToUser_NoticeToUser__rsCsg","info_message":"NoticeToUser_info_message__CiI0v"};